import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Chip,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import { userDataFromLocal } from '../utils/getUserDetails';
import DialogMsg from '../../global/DialogMsg';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { FaCamera } from 'react-icons/fa';
import { Close, VideoCall } from '@mui/icons-material';
import { fDate, fDateTime, fDateTimeSuffix } from '../utils/formatTime';
import { useTranslation } from 'react-i18next';

const { GetBookedSlotDetails, ScheduleDetails, BookAgentSlot, GenerateTokenForEKYC } =
  onBoardingEkycServices;

const ScheduleVkyc = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [dialogMsg, setDialogMsg] = useState(false);
  const [openDialogSlot, setOpenDialogSlot] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [getBookedSlotDetailsList, setGetBookedSlotDetailsList] = useState(null);
  const [scheduleDetailsList, setScheduleDetailsList] = useState([]);
  const [calendarValue, onChange] = useState(new Date());
  const [searchingDate, setSearchingDate] = useState('');
  const [selectedTime, setSelectedTime] = useState({});
  const [isSelect, setIsSelect] = useState(false);
  const [iSlotBooked, setISlotBooked] = useState(false);
  const [bookSlotTimePrint, setBookSlotTimePrint] = useState('');

  // console.log('calendarValuecalendarValue', selectedTime);
  // console.log('calendarValuecalendarValue', calendarValue);

  // getBookedSlotDetailsApi API
  const getBookedSlotDetailsApi = async (searchDate, slot_id, user_id) => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();

      const headerCredential = {
        applicationNo: userData?.applicationNo,
        bookingDate: searchDate,
        slotId: slot_id,
        userId: user_id
      };

      const GetBookedSlotDetailsResponse = await GetBookedSlotDetails(headerCredential);
      if (GetBookedSlotDetailsResponse.status === 'Success') {
        setGetBookedSlotDetailsList(GetBookedSlotDetailsResponse.data);
        // date time print when booked slot day and time
        if (
          GetBookedSlotDetailsResponse.data !== null &&
          GetBookedSlotDetailsResponse.data !== undefined
        ) {
          const dateTime = new Date(GetBookedSlotDetailsResponse?.data?.bookingDate);
          const dateFunction = fDate(dateTime);
          const dayOfWeekString = dateTime.toLocaleDateString('en-US', { weekday: 'short' });
          const dateTimeFunction = `${dateFunction}, ${dayOfWeekString} ${GetBookedSlotDetailsResponse?.data?.startTime}`;
          setBookSlotTimePrint(dateTimeFunction);
        }
        // date time print when booked slot day and time
      } else if (GetBookedSlotDetailsResponse.status === 'Failed') {
        setOpenDialogeMsg(true);
        setDialogMsg(GetBookedSlotDetailsResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };
  // handleScheduleDetailsApi API
  const handleScheduleDetailsApi = async (date) => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();

      const getDate = new Date(date);
      const getYYMMDD = `${getDate.getFullYear()}-${getDate.getMonth() + 1}-${getDate.getDate()}`;
      const getStringDate = getYYMMDD.toString();
      setSearchingDate(getStringDate);

      const headerCredential = {
        applicationNo: userData?.applicationNo,
        searchDate: getStringDate
        // searchDate: '2024-01-09'
      };

      const ScheduleDetailsResponse = await ScheduleDetails(headerCredential);
      if (ScheduleDetailsResponse.status === 'Success') {
        ScheduleDetailsResponse.data.forEach((element) => {
          element.isActive = false;
        });
        setScheduleDetailsList(ScheduleDetailsResponse.data);
      } else if (ScheduleDetailsResponse.status === 'Failed') {
        setOpenDialogeMsg(true);
        setDialogMsg(ScheduleDetailsResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };
  // handleBookAgentSlotApi API
  const handleBookAgentSlotApi = async () => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();

      const headerCredential = {
        applicationNo: userData?.applicationNo,
        bookingDate: searchingDate, // converted all ready yyyy-mm-dd format as required to backend
        slotId: selectedTime?.slotId,
        userId: selectedTime?.userId
      };

      const BookAgentSlotResponse = await BookAgentSlot(headerCredential);
      if (BookAgentSlotResponse.status === 'Success') {
        setOpenDialogSlot(true);
        // setISlotBooked(true);
        // setDialogMsg('Successfully slot has been booked');
        // setOpenDialogeMsg(true);
        // setTimeout(() => {
        //   setOpenDialogeMsg(false);
        // }, 1000);
        getBookedSlotDetailsApi(searchingDate, selectedTime?.slotId, selectedTime?.userId); // again load bookedSlotDetailsApi when book agent slot
      } else if (BookAgentSlotResponse.status === 'Failed') {
        setOpenDialogeMsg(true);
        setDialogMsg(BookAgentSlotResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };

  // Msg Dialog close handler
  const handleClickChip = (item, index) => {
    console.log('isActiveisActive', item);
    // const prevArray = [...scheduleDetailsList];
    // prevArray[index].isActive = !prevArray[index].isActive;

    const prevArray = scheduleDetailsList.map((schedule, i) => ({
      ...schedule,
      isActive: i === index ? !schedule.isActive : false
    }));
    setScheduleDetailsList(prevArray);
  };

  // handleGenerateTokenApi API
  // const handleGenerateTokenApi = async () => {
  //   try {
  //     setOpenloader(true);
  //     const userData = userDataFromLocal();

  //     const headerCredential = {
  //       // application_no: userData?.applicationNo
  //       applicationNo: userData?.applicationNo
  //     };

  //     const GenerateTokenResponse = await GenerateTokenForEKYC(headerCredential);
  //     if (GenerateTokenResponse.status === 'Success') {
  //       // const channelName = CryptoJS.AES.encrypt(
  //       //   GenerateTokenResponse?.data?.channel,
  //       //   'channel'
  //       // ).toString();
  //       const token = CryptoJS.AES.encrypt(
  //         GenerateTokenResponse?.data?.token,
  //         'userToken'
  //       ).toString();
  //       localStorage.setItem('callToken', GenerateTokenResponse?.data?.token);
  //       localStorage.setItem('channel', GenerateTokenResponse?.data?.channel);
  //       navigate(
  //         `/in/video-kyc?t=${GenerateTokenResponse?.data?.token}&c=${GenerateTokenResponse?.data?.channel}`
  //       );
  //       // // Check if 'existingJourney' exists in local storage, parse it from JSON, or initialize as an empty object
  //       // let existingJourney = localStorage.getItem('journey');
  //       // // If 'journey' already exists, parse it from JSON
  //       // existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
  //       // const newData = {
  //       //   ...existingJourney,
  //       //   generateToken: GenerateTokenResponse.data
  //       // };
  //       // localStorage.setItem('journey', JSON.stringify(newData));
  //     } else if (GenerateTokenResponse.status === 'Failed') {
  //       setOpenDialogeMsg(true);
  //       setDialogMsg(GenerateTokenResponse.message);
  //     } else {
  //       setOpenDialogeMsg(true);
  //       setDialogMsg('Something went wrong');
  //     }
  //   } catch (error) {
  //     console.log('errorerror', error);
  //   } finally {
  //     setOpenloader(false);
  //   }
  // };

  // Msg Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
    setDialogMsg('');
  };

  useEffect(() => {
    if (searchingDate === '') {
      const getDate = new Date();
      handleScheduleDetailsApi(getDate);
    }

    // getBookedSlotDetailsApi(); parameters are not available if fired before book agent slot
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle="Appointment schedule" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box>
          <Grid container columnSpacing={{ xs: 1, sm: 4, md: 5 }}>
            <Grid item xs="12" sm="6" md="6" mr={5} marginBottom={3}>
              <Typography variant="body1" mb={1} style={{ fontWeight: 'bold' }}>
                {t('Book calendar')}
              </Typography>
              <Typography mb={2}>
                <Calendar
                  // onChange={onChange}
                  onChange={(e) => {
                    onChange(e);
                    handleScheduleDetailsApi(e);
                  }}
                  value={calendarValue}
                />
              </Typography>
              {scheduleDetailsList.length > 0 ? (
                <>
                  <Typography variant="body1" mb={1} style={{ fontWeight: 'bold' }}>
                    {t('Select Available Time')}{' '}
                    {iSlotBooked ? (
                      <Typography variant="body2" mb={1} style={{ color: 'green' }}>
                        {t('Video kyc slot has been booked at')} {selectedTime?.slotStartTime}
                      </Typography>
                    ) : (
                      ''
                    )}
                  </Typography>
                  <Box mb={2} className="card" display="flex" flexWrap="wrap">
                    {scheduleDetailsList?.map((item, index) => (
                      <Chip
                        variant="outlined"
                        size="small"
                        key={`chip-${index}`}
                        clickable
                        label={item?.slotStartTime}
                        style={{
                          marginBottom: '7px',
                          marginRight: '7px',
                          fontWeight: 'bold',
                          background: item.isActive ? '#00bbbf' : '#fff',
                          color: item.isActive ? '#fff' : '#3C3C4B'
                        }}
                        onClick={() => {
                          handleClickChip(item, index);
                          setSelectedTime(item);
                          // isSelectedItem(item);
                        }}
                      />
                    ))}
                  </Box>
                </>
              ) : (
                t('Schedule is not available right now Please book slot first')
              )}

              <Box mt={2}>
                <Button
                  className="mainBtn btnLink"
                  onClick={() => {
                    if (!scheduleDetailsList.length > 0) {
                      setDialogMsg('Please select date first');
                      setOpenDialogeMsg(true);
                    } else if (!Object.keys(selectedTime).length) {
                      setDialogMsg('Please select time first');
                      setOpenDialogeMsg(true);
                    } else {
                      setOpenDialogeMsg(false);
                      handleBookAgentSlotApi();
                    }
                  }}
                >
                  {t('Book Appointment')}
                </Button>
              </Box>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item xs="12" sm="5" md="5" marginBottom={3}>
              <Typography variant="body1" mb={1} style={{ fontWeight: 'bold' }}>
                {t('Booked slot')}
              </Typography>
              {getBookedSlotDetailsList !== null ? (
                <Box mb={3} className="card" position="relative">
                  <Typography variant="body2">{getBookedSlotDetailsList.bookingDate}</Typography>
                  <Typography variant="body2" mt={1} mb={1} style={{ fontWeight: 'bold' }}>
                    {getBookedSlotDetailsList.applicationNo}
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    {t(getBookedSlotDetailsList.status)}
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{
                      position: 'absolute',
                      right: '10px',
                      bottom: '10px'
                    }}
                  >
                    <Chip
                      size="small"
                      icon={<VideoCall />}
                      label={t('Join a call')}
                      clickable
                      color="success"
                      // style={{ opacity: '0.5', cursor: 'auto' }}
                      style={{ opacity: '1' }}
                      onClick={() => {
                        // handleGenerateTokenApi();
                        navigate('/in/video-kyc');
                      }}
                      // deleteIcon={<DoneIcon />}
                    />
                  </Typography>
                </Box>
              ) : (
                t('Slot is not available right now Please book calendar first')
              )}
            </Grid>
          </Grid>
        </Box>

        {/* Slot booked alert dialog */}
        <Dialog
          fullWidth
          maxWidth="sm"
          open={openDialogSlot}
          onClose={() => {
            setOpenDialogSlot(false);
          }}
          className="alertDialogWrap"
        >
          <DialogTitle className="dialog-title" style={{ textAlign: 'center' }}>
            <Typography variant="subtitle1">{t('Message')}</Typography>
            <IconButton onClick={() => setOpenDialogSlot(false)} size="small">
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2" fontWeight="bold" mb={2}>
              {t('You have booked appointment on')}
            </Typography>
            <Typography variant="body2">
              {
                bookSlotTimePrint
                // if(getBookedSlotDetailsList !== null){
                //   const dateTime = new Date(getBookedSlotDetailsList?.bookingDate);
                //   getBookedSlotDetailsList.
                // }
              }
            </Typography>
          </DialogContent>

          <DialogActions disableSpacing={false} className="popupAction" style={{ padding: '15px' }}>
            <Button
              style={{ backgroundColor: '#111b53' }}
              className="mainBtn"
              variant="contained"
              color="secondary"
              onClick={() => {
                setOpenDialogSlot(false);
              }}
            >
              {t('Confirm')}
            </Button>
            <Button
              onClick={() => setOpenDialogSlot(false)}
              variant="contained"
              className="mainBtn"
              color="primary"
            >
              {t('Close')}
            </Button>
          </DialogActions>
        </Dialog>

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Message"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default ScheduleVkyc;
